import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import {ProductConfiguratorComponent} from './configurator-component/product-configurator.component';
import {OrderDialogComponent} from './order-dialog/order-dialog.component';

import {ParameterLoaderService} from './parameters/parameter-loader.service';
import {TextboxBasicComponent} from './parameters/textbox-basic/textbox-basic.component';
import {PickerBasicComponent} from './parameters/picker-basic/picker-basic.component';
import {ParameterCardComponent} from './parameters/parameter-card/parameter-card.component';
import {SliderBasicComponent} from './parameters/slider-basic/slider-basic.component';
import {DropdownComponent} from './parameters/dropdown/dropdown.component';

import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';

import {MatCheckboxModule} from '@angular/material/checkbox';
import {ReactiveFormsModule} from '@angular/forms';

import {NgxTwikitWebPluginModule} from '@twikit/ngx-twikit-web-plugin';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {DropdownSliderBasicComponent} from './parameters/dropdown-slider-basic/dropdown-slider-basic.component';
import {CameraControlsComponent} from './camera-controls/camera-controls.component';

import { environment } from '../../environments/environment';

@NgModule({
  declarations: [
    ProductConfiguratorComponent,
    TextboxBasicComponent,
    PickerBasicComponent,
    SliderBasicComponent,
    DropdownSliderBasicComponent,
    DropdownComponent,
    ParameterCardComponent,
    OrderDialogComponent,
    CameraControlsComponent
  ],
  providers: [
    ParameterLoaderService
  ],
  exports: [
    ProductConfiguratorComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSelectModule,
    NgxTwikitWebPluginModule.forRoot(environment.pluginUrl),
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTabsModule,
    MatProgressBarModule,
    MatCheckboxModule,
    HttpClientModule
  ],
  entryComponents: [
    PickerBasicComponent,
    TextboxBasicComponent,
    SliderBasicComponent,
    DropdownComponent,
    OrderDialogComponent,
    CameraControlsComponent
  ]
})
export class ProductConfiguratorModule {
}
